/*
Controller: Designers

Operations:
  getDesigners
  checkUniqueDesigners
*/
var Api = require('../config')
var DesignersCheckUniqueDef = require('../definitions/DesignersCheckUnique')

var Designers = (function () {
  /*
  Operation: getDesigners
  Query existing designers
  Parameters:
    name: Designer name
  Responses:
    HTTP 200: List of designers
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getDesignersDesigners (name) {
    return new Promise(function (resolve, reject) {
      try {
        if (!name) {
          throw new Error('name: Missing parameter')
        }
        if (name && !(typeof name === 'string')) {
          throw new Error('name: Wrong type: Got "' + (typeof name) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['name'] = name
      var path = '/designers'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: checkUniqueDesigners
  Will check if array of designers already exist in PIM
  Parameters:

  Responses:
    HTTP 200: Designers Check performed
    HTTP 403: Operation not permitted
  */
  function checkUniqueDesignersDesigners (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        DesignersCheckUniqueDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/designers/checkUnique'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getDesigners'] = getDesignersDesigners
  ret['checkUniqueDesigners'] = checkUniqueDesignersDesigners
  return ret
})()

module.exports = Designers
